import React, { useState } from 'react';
import { Package, Search, Plus, MapPin, Phone, User, Clock, CheckCircle, XCircle, AlertCircle, LogOut, Settings, Edit2, Trash2, Save, X, MessageSquare, DollarSign, Users, MapPinned, FileText, Box, AlertTriangle, Zap, Package2, CreditCard, IdCard } from 'lucide-react';

export default function OperatorInterface() {
  const companies = {
    somatra: {
      name: "Somatra Transport",
      logo: "ST",
      colorClasses: {
        primary: "bg-blue-600",
        primaryHover: "hover:bg-blue-700",
        primaryLight: "bg-blue-50",
        primaryText: "text-blue-600",
        primaryBorder: "border-blue-600"
      }
    },
    diarra: {
      name: "Diarra Transport",
      logo: "DT",
      colorClasses: {
        primary: "bg-emerald-600",
        primaryHover: "hover:bg-emerald-700",
        primaryLight: "bg-emerald-50",
        primaryText: "text-emerald-600",
        primaryBorder: "border-emerald-600"
      }
    },
    smt: {
      name: "SMT Mali",
      logo: "SMT",
      colorClasses: {
        primary: "bg-orange-600",
        primaryHover: "hover:bg-orange-700",
        primaryLight: "bg-orange-50",
        primaryText: "text-orange-600",
        primaryBorder: "border-orange-600"
      }
    }
  };

  const packageIcons = {
    'FileText': FileText,
    'Box': Box,
    'AlertTriangle': AlertTriangle,
    'Zap': Zap,
    'Package2': Package2
  };

  const [currentCompany, setCurrentCompany] = useState('somatra');
  const [view, setView] = useState('dashboard');
  const [searchTerm, setSearchTerm] = useState('');
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [pickupDrawerOpen, setPickupDrawerOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [pickupPackage, setPickupPackage] = useState(null);
  const [adminSection, setAdminSection] = useState('destinations');
  const [dateFilter, setDateFilter] = useState('today');
  const [editingItem, setEditingItem] = useState(null);
  const [addingNew, setAddingNew] = useState(false);
  const [newItem, setNewItem] = useState(null);

  const currentOperator = {
    name: "Aminata Traoré",
    location: "Bamako Centre",
    phone: "+223 70 11 22 33"
  };
  
  const [pickupForm, setPickupForm] = useState({
    idNumber: '',
    trackingLookup: '',
    phoneLookup: ''
  });

  const [packageTypes, setPackageTypes] = useState([
    { id: 1, name: 'Documents', basePrice: 2000, icon: 'FileText' },
    { id: 2, name: 'Colis Standard', basePrice: 5000, icon: 'Box' },
    { id: 3, name: 'Fragile', basePrice: 7500, icon: 'AlertTriangle' },
    { id: 4, name: 'Express', basePrice: 10000, icon: 'Zap' },
    { id: 5, name: 'Volumineux', basePrice: 15000, icon: 'Package2' }
  ]);

  const [destinations, setDestinations] = useState([
    { id: 1, name: 'Bamako Centre', code: 'BAM', priceMultiplier: 1.0, active: true },
    { id: 2, name: 'Bamako Medina', code: 'BAM', priceMultiplier: 1.0, active: true },
    { id: 3, name: 'Sikasso', code: 'SKS', priceMultiplier: 1.5, active: true },
    { id: 4, name: 'Kayes', code: 'KAY', priceMultiplier: 1.8, active: true },
    { id: 5, name: 'Mopti', code: 'MOP', priceMultiplier: 2.0, active: true },
    { id: 6, name: 'Ségou', code: 'SEG', priceMultiplier: 1.3, active: true }
  ]);

  const [operators, setOperators] = useState([
    { id: 1, name: 'Aminata Traoré', phone: '+223 70 11 22 33', location: 'Bamako Centre', active: true },
    { id: 2, name: 'Ibrahim Diarra', phone: '+223 70 44 55 66', location: 'Sikasso', active: true },
    { id: 3, name: 'Sekou Touré', phone: '+223 70 77 88 99', location: 'Kayes', active: false }
  ]);

  const [packages, setPackages] = useState([
    {
      id: 1,
      tracking: "BAM-SKS-100925-7654",
      sender: "Mamadou Konaté",
      senderPhone: "+223 70 12 34 56",
      recipient: "Fatoumata Diallo",
      recipientPhone: "+223 76 98 76 54",
      origin: "Bamako Centre",
      destination: "Sikasso",
      packageType: "Colis Standard",
      price: 7500,
      status: "arrived",
      registeredAt: "09 Oct 2025, 09:15",
      arrivedAt: "09 Oct 2025, 15:45",
      description: "Pièces électroniques",
      timeline: [
        { event: "Enregistré", time: "09 Oct, 09:15", operator: "Aminata Traoré" },
        { event: "SMS envoyé à l'expéditeur", time: "09 Oct, 09:15", type: "sms" },
        { event: "SMS envoyé au destinataire", time: "09 Oct, 09:15", type: "sms" },
        { event: "En transit", time: "09 Oct, 12:30", operator: "Chauffeur" },
        { event: "Arrivé à Sikasso", time: "09 Oct, 15:45", operator: "Ibrahim Diarra" },
        { event: "SMS envoyé au destinataire", time: "09 Oct, 15:45", type: "sms" }
      ],
      messages: [
        { to: "Expéditeur (+223 70 12 34 56)", text: "Colis enregistré! Suivi: BAM-SKS-100925-7654. De Bamako → Sikasso. Confirmation envoyée quand destinataire récupère.", time: "09:15", status: "delivered" },
        { to: "Destinataire (+223 76 98 76 54)", text: "Un colis vous est envoyé! Suivi: BAM-SKS-100925-7654. De: Mamadou Konaté. Notification à l'arrivée.", time: "09:15", status: "delivered" },
        { to: "Destinataire (+223 76 98 76 54)", text: "Votre colis est arrivé! Lieu: Dépôt Sikasso. Apporter pièce d'identité + N° suivi. Horaires: 8h-18h.", time: "15:45", status: "delivered" }
      ]
    },
    {
      id: 2,
      tracking: "BAM-KAY-100925-3421",
      sender: "Ibrahim Traoré",
      senderPhone: "+223 70 45 67 89",
      recipient: "Aminata Coulibaly",
      recipientPhone: "+223 76 54 34 21",
      origin: "Bamako Medina",
      destination: "Kayes",
      packageType: "Documents",
      price: 3600,
      status: "in_transit",
      registeredAt: "09 Oct 2025, 11:30",
      description: "Documents administratifs",
      timeline: [
        { event: "Enregistré", time: "09 Oct, 11:30", operator: "Aminata Traoré" },
        { event: "SMS envoyé à l'expéditeur", time: "09 Oct, 11:30", type: "sms" },
        { event: "SMS envoyé au destinataire", time: "09 Oct, 11:30", type: "sms" },
        { event: "En transit vers Kayes", time: "09 Oct, 14:00", operator: "Chauffeur" }
      ],
      messages: [
        { to: "Expéditeur (+223 70 45 67 89)", text: "Colis enregistré! Suivi: BAM-KAY-100925-3421. De Bamako → Kayes.", time: "11:30", status: "delivered" },
        { to: "Destinataire (+223 76 54 34 21)", text: "Un colis vous est envoyé! Suivi: BAM-KAY-100925-3421. De: Ibrahim Traoré.", time: "11:30", status: "delivered" }
      ]
    },
    {
      id: 3,
      tracking: "SKS-BAM-091025-2341",
      sender: "Sekou Diarra",
      senderPhone: "+223 70 23 45 67",
      recipient: "Mariam Touré",
      recipientPhone: "+223 76 12 23 41",
      origin: "Sikasso",
      destination: "Bamako Centre",
      packageType: "Express",
      price: 15000,
      status: "picked_up",
      registeredAt: "09 Oct 2025, 08:00",
      arrivedAt: "09 Oct 2025, 13:30",
      pickedUpAt: "09 Oct 2025, 16:20",
      description: "Contrat urgent",
      timeline: [
        { event: "Enregistré", time: "09 Oct, 08:00", operator: "Ibrahim Diarra" },
        { event: "SMS envoyé à l'expéditeur", time: "09 Oct, 08:00", type: "sms" },
        { event: "SMS envoyé au destinataire", time: "09 Oct, 08:00", type: "sms" },
        { event: "Arrivé à Bamako Centre", time: "09 Oct, 13:30", operator: "Aminata Traoré" },
        { event: "SMS envoyé au destinataire", time: "09 Oct, 13:30", type: "sms" },
        { event: "Récupéré par destinataire", time: "09 Oct, 16:20", operator: "Aminata Traoré" },
        { event: "SMS envoyé à l'expéditeur", time: "09 Oct, 16:20", type: "sms" }
      ],
      messages: []
    },
    {
      id: 4,
      tracking: "BAM-MOP-091025-8765",
      sender: "Boubacar Keita",
      senderPhone: "+223 70 56 78 90",
      recipient: "Kadiatou Sanogo",
      recipientPhone: "+223 76 98 87 65",
      origin: "Bamako Centre",
      destination: "Mopti",
      packageType: "Volumineux",
      price: 30000,
      status: "in_transit",
      registeredAt: "09 Oct 2025, 07:45",
      description: "Équipement médical",
      timeline: [],
      messages: []
    },
    {
      id: 5,
      tracking: "KAY-BAM-091025-5432",
      sender: "Modibo Sidibé",
      senderPhone: "+223 70 34 56 78",
      recipient: "Awa Diallo",
      recipientPhone: "+223 76 45 54 32",
      origin: "Kayes",
      destination: "Bamako Medina",
      packageType: "Colis Standard",
      price: 9000,
      status: "arrived",
      registeredAt: "09 Oct 2025, 06:30",
      arrivedAt: "09 Oct 2025, 14:15",
      description: "Vêtements traditionnels",
      timeline: [],
      messages: []
    },
    {
      id: 6,
      tracking: "SEG-SKS-081025-6789",
      sender: "Youssouf Koné",
      senderPhone: "+223 70 67 89 01",
      recipient: "Salimata Camara",
      recipientPhone: "+223 76 78 67 89",
      origin: "Ségou",
      destination: "Sikasso",
      packageType: "Fragile",
      price: 9750,
      status: "picked_up",
      registeredAt: "08 Oct 2025, 10:00",
      arrivedAt: "08 Oct 2025, 18:30",
      pickedUpAt: "09 Oct 2025, 09:15",
      description: "Poterie artisanale",
      timeline: [],
      messages: []
    },
    {
      id: 7,
      tracking: "BAM-KAY-091025-3210",
      sender: "Abdoulaye Diarra",
      senderPhone: "+223 70 12 34 56",
      recipient: "Fatim Coulibaly",
      recipientPhone: "+223 76 23 32 10",
      origin: "Bamako Centre",
      destination: "Kayes",
      packageType: "Documents",
      price: 3600,
      status: "in_transit",
      registeredAt: "09 Oct 2025, 13:20",
      description: "Dossier juridique",
      timeline: [],
      messages: []
    },
    {
      id: 8,
      tracking: "MOP-BAM-081025-9876",
      sender: "Alassane Traoré",
      senderPhone: "+223 70 98 76 54",
      recipient: "Hawa Sankara",
      recipientPhone: "+223 76 87 98 76",
      origin: "Mopti",
      destination: "Bamako Centre",
      packageType: "Express",
      price: 20000,
      status: "arrived",
      registeredAt: "08 Oct 2025, 09:00",
      arrivedAt: "09 Oct 2025, 07:30",
      description: "Échantillons tissus",
      timeline: [],
      messages: []
    },
    {
      id: 9,
      tracking: "SKS-SEG-091025-4321",
      sender: "Drissa Bagayoko",
      senderPhone: "+223 70 43 21 09",
      recipient: "Rokia Dembélé",
      recipientPhone: "+223 76 34 43 21",
      origin: "Sikasso",
      destination: "Ségou",
      packageType: "Colis Standard",
      price: 6500,
      status: "in_transit",
      registeredAt: "09 Oct 2025, 10:45",
      description: "Produits agricoles",
      timeline: [],
      messages: []
    },
    {
      id: 10,
      tracking: "BAM-SKS-081025-5678",
      sender: "Lassana Sangaré",
      senderPhone: "+223 70 56 78 90",
      recipient: "Aissata Koné",
      recipientPhone: "+223 76 67 56 78",
      origin: "Bamako Medina",
      destination: "Sikasso",
      packageType: "Fragile",
      price: 11250,
      status: "picked_up",
      registeredAt: "08 Oct 2025, 11:30",
      arrivedAt: "08 Oct 2025, 19:45",
      pickedUpAt: "09 Oct 2025, 08:00",
      description: "Instruments de musique",
      timeline: [],
      messages: []
    },
    {
      id: 11,
      tracking: "KAY-MOP-091025-7890",
      sender: "Oumar Cissé",
      senderPhone: "+223 70 78 90 12",
      recipient: "Bintou Sylla",
      recipientPhone: "+223 76 89 78 90",
      origin: "Kayes",
      destination: "Mopti",
      packageType: "Volumineux",
      price: 36000,
      status: "in_transit",
      registeredAt: "09 Oct 2025, 08:15",
      description: "Mobilier de bureau",
      timeline: [],
      messages: []
    },
    {
      id: 12,
      tracking: "BAM-SEG-091025-2345",
      sender: "Mahamadou Diakité",
      senderPhone: "+223 70 23 45 67",
      recipient: "Safiatou Traoré",
      recipientPhone: "+223 76 34 23 45",
      origin: "Bamako Centre",
      destination: "Ségou",
      packageType: "Colis Standard",
      price: 6500,
      status: "arrived",
      registeredAt: "09 Oct 2025, 09:30",
      arrivedAt: "09 Oct 2025, 15:00",
      description: "Livres scolaires",
      timeline: [],
      messages: []
    },
    {
      id: 13,
      tracking: "SEG-BAM-071025-6543",
      sender: "Tiemoko Bamba",
      senderPhone: "+223 70 65 43 21",
      recipient: "Fatoumata Sissoko",
      recipientPhone: "+223 76 54 65 43",
      origin: "Ségou",
      destination: "Bamako Medina",
      packageType: "Express",
      price: 13000,
      status: "picked_up",
      registeredAt: "07 Oct 2025, 14:00",
      arrivedAt: "08 Oct 2025, 08:30",
      pickedUpAt: "08 Oct 2025, 11:45",
      description: "Documents notariés",
      timeline: [],
      messages: []
    },
    {
      id: 14,
      tracking: "SKS-KAY-091025-8901",
      sender: "Souleymane Koné",
      senderPhone: "+223 70 89 01 23",
      recipient: "Nana Traoré",
      recipientPhone: "+223 76 90 89 01",
      origin: "Sikasso",
      destination: "Kayes",
      packageType: "Documents",
      price: 3600,
      status: "in_transit",
      registeredAt: "09 Oct 2025, 12:00",
      description: "Actes administratifs",
      timeline: [],
      messages: []
    },
    {
      id: 15,
      tracking: "MOP-SEG-081025-1234",
      sender: "Bakary Coulibaly",
      senderPhone: "+223 70 12 34 56",
      recipient: "Aminata Maiga",
      recipientPhone: "+223 76 23 12 34",
      origin: "Mopti",
      destination: "Ségou",
      packageType: "Colis Standard",
      price: 6500,
      status: "arrived",
      registeredAt: "08 Oct 2025, 13:45",
      arrivedAt: "09 Oct 2025, 10:20",
      description: "Matériel informatique",
      timeline: [],
      messages: []
    },
    {
      id: 16,
      tracking: "BAM-SKS-071025-9012",
      sender: "Cheick Diarra",
      senderPhone: "+223 70 90 12 34",
      recipient: "Coumba Fofana",
      recipientPhone: "+223 76 01 90 12",
      origin: "Bamako Centre",
      destination: "Sikasso",
      packageType: "Fragile",
      price: 11250,
      status: "picked_up",
      registeredAt: "07 Oct 2025, 08:30",
      arrivedAt: "07 Oct 2025, 16:45",
      pickedUpAt: "08 Oct 2025, 09:30",
      description: "Équipement photographique",
      timeline: [],
      messages: []
    },
    {
      id: 17,
      tracking: "KAY-BAM-091025-3456",
      sender: "Moussa Keita",
      senderPhone: "+223 70 34 56 78",
      recipient: "Djénéba Sidibé",
      recipientPhone: "+223 76 45 34 56",
      origin: "Kayes",
      destination: "Bamako Centre",
      packageType: "Express",
      price: 18000,
      status: "in_transit",
      registeredAt: "09 Oct 2025, 11:15",
      description: "Médicaments urgents",
      timeline: [],
      messages: []
    },
    {
      id: 18,
      tracking: "SEG-MOP-091025-5678",
      sender: "Lancine Doumbia",
      senderPhone: "+223 70 56 78 90",
      recipient: "Aïcha Touré",
      recipientPhone: "+223 76 67 56 78",
      origin: "Ségou",
      destination: "Mopti",
      packageType: "Volumineux",
      price: 26000,
      status: "arrived",
      registeredAt: "09 Oct 2025, 07:00",
      arrivedAt: "09 Oct 2025, 16:30",
      description: "Machine agricole",
      timeline: [],
      messages: []
    }
  ]);

  const [formData, setFormData] = useState({
    senderName: '',
    senderPhone: '70 ',
    recipientName: '',
    recipientPhone: '76 ',
    origin: currentOperator.location,
    destination: '',
    packageType: '',
    description: '',
    photo: null,
    priceOverride: ''
  });

  const company = companies[currentCompany];
  const colors = company.colorClasses;

  const statusLabels = {
    registered: { text: "Enregistré", color: "bg-gray-100 text-gray-700", dot: "bg-gray-500" },
    in_transit: { text: "En Transit", color: "bg-yellow-100 text-yellow-700", dot: "bg-yellow-500" },
    arrived: { text: "Arrivé", color: "bg-blue-100 text-blue-700", dot: "bg-blue-500" },
    picked_up: { text: "Récupéré", color: "bg-green-100 text-green-700", dot: "bg-green-500" }
  };

  const calculatePrice = () => {
    if (!formData.packageType || !formData.destination) return 0;
    const pkgType = packageTypes.find(t => t.name === formData.packageType);
    const dest = destinations.find(d => d.name === formData.destination);
    if (!pkgType || !dest) return 0;
    return Math.round(pkgType.basePrice * dest.priceMultiplier);
  };

  const generateTrackingNumber = () => {
    const origin = destinations.find(d => d.name === formData.origin);
    const dest = destinations.find(d => d.name === formData.destination);
    if (!origin || !dest) return '';
    const date = new Date();
    const dateStr = `${String(date.getDate()).padStart(2, '0')}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getFullYear()).slice(-2)}`;
    const lastFour = formData.recipientPhone.replace(/\s/g, '').slice(-4);
    return `${origin.code}-${dest.code}-${dateStr}-${lastFour}`;
  };

  const handleRegister = () => {
    if (!formData.senderName || !formData.senderPhone || !formData.recipientName || 
        !formData.recipientPhone || !formData.origin || !formData.destination || !formData.packageType) {
      alert('Veuillez remplir tous les champs obligatoires');
      return;
    }

    const newPackage = {
      id: packages.length + 1,
      tracking: generateTrackingNumber(),
      sender: formData.senderName,
      senderPhone: '+223 ' + formData.senderPhone.trim(),
      recipient: formData.recipientName,
      recipientPhone: '+223 ' + formData.recipientPhone.trim(),
      origin: formData.origin,
      destination: formData.destination,
      packageType: formData.packageType,
      price: formData.priceOverride ? parseInt(formData.priceOverride) : calculatePrice(),
      status: "registered",
      photo: formData.photo ? URL.createObjectURL(formData.photo) : null,
      registeredAt: new Date().toLocaleString('fr-FR', { 
        day: '2-digit', 
        month: 'short', 
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }),
      description: formData.description,
      timeline: [
        { event: "Enregistré", time: new Date().toLocaleString('fr-FR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }), operator: "Aminata Traoré" },
        { event: "SMS envoyé à l'expéditeur", time: new Date().toLocaleString('fr-FR', { hour: '2-digit', minute: '2-digit' }), type: "sms" },
        { event: "SMS envoyé au destinataire", time: new Date().toLocaleString('fr-FR', { hour: '2-digit', minute: '2-digit' }), type: "sms" }
      ],
      messages: [
        { to: `Expéditeur (+223 ${formData.senderPhone.trim()})`, text: `Colis enregistré! Suivi: ${generateTrackingNumber()}. De ${formData.origin} → ${formData.destination}.`, time: new Date().toLocaleString('fr-FR', { hour: '2-digit', minute: '2-digit' }), status: "delivered" },
        { to: `Destinataire (+223 ${formData.recipientPhone.trim()})`, text: `Un colis vous est envoyé! Suivi: ${generateTrackingNumber()}. De: ${formData.senderName}.`, time: new Date().toLocaleString('fr-FR', { hour: '2-digit', minute: '2-digit' }), status: "delivered" }
      ]
    };

    setPackages([newPackage, ...packages]);
    setFormData({
      senderName: '',
      senderPhone: '70 ',
      recipientName: '',
      recipientPhone: '76 ',
      origin: currentOperator.location,
      destination: '',
      packageType: '',
      description: '',
      photo: null,
      priceOverride: ''
    });
    setView('dashboard');
    alert(`Colis enregistré!\n\nNuméro: ${newPackage.tracking}\nPrix: ${newPackage.price} CFA\n\n2 SMS envoyés`);
  };

  const updateStatus = (packageId, newStatus) => {
    const pkg = packages.find(p => p.id === packageId);
    const updatedPackage = {
      ...pkg,
      status: newStatus,
      ...(newStatus === 'arrived' && { 
        arrivedAt: new Date().toLocaleString('fr-FR'),
        timeline: [...(pkg.timeline || []), 
          { event: `Arrivé à ${pkg.destination}`, time: new Date().toLocaleString('fr-FR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }), operator: "Ibrahim Diarra" },
          { event: "SMS envoyé au destinataire", time: new Date().toLocaleString('fr-FR', { hour: '2-digit', minute: '2-digit' }), type: "sms" }
        ],
        messages: [...(pkg.messages || []),
          { to: `Destinataire (${pkg.recipientPhone})`, text: `Votre colis est arrivé! Lieu: Dépôt ${pkg.destination}. Apporter pièce d'identité + N° suivi.`, time: new Date().toLocaleString('fr-FR', { hour: '2-digit', minute: '2-digit' }), status: "delivered" }
        ]
      })
    };
    
    setPackages(packages.map(p => p.id === packageId ? updatedPackage : p));
    
    if (selectedPackage?.id === packageId) {
      setSelectedPackage(updatedPackage);
    }
    
    alert("Statut mis à jour\nSMS envoyé au destinataire");
  };

  const handlePickupSubmit = () => {
    if (!pickupForm.idNumber.trim()) {
      alert('Le numéro de pièce d\'identité est obligatoire');
      return;
    }

    // Verify tracking or phone if provided
    if (pickupForm.trackingLookup && pickupForm.trackingLookup !== pickupPackage.tracking) {
      alert('Numéro de suivi incorrect');
      return;
    }

    if (pickupForm.phoneLookup && !pickupPackage.recipientPhone.includes(pickupForm.phoneLookup)) {
      alert('Numéro de téléphone incorrect');
      return;
    }

    const updatedPackage = {
      ...pickupPackage,
      status: 'picked_up',
      pickedUpAt: new Date().toLocaleString('fr-FR'),
      idVerified: pickupForm.idNumber,
      timeline: [...(pickupPackage.timeline || []),
        { event: "Récupéré par destinataire", time: new Date().toLocaleString('fr-FR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }), operator: "Aminata Traoré" },
        { event: "SMS envoyé à l'expéditeur", time: new Date().toLocaleString('fr-FR', { hour: '2-digit', minute: '2-digit' }), type: "sms" }
      ],
      messages: [...(pickupPackage.messages || []),
        { to: `Expéditeur (${pickupPackage.senderPhone})`, text: `Colis livré! Suivi: ${pickupPackage.tracking}. Récupéré le ${new Date().toLocaleDateString('fr-FR')}.`, time: new Date().toLocaleString('fr-FR', { hour: '2-digit', minute: '2-digit' }), status: "delivered" }
      ]
    };

    setPackages(packages.map(p => p.id === pickupPackage.id ? updatedPackage : p));
    
    if (selectedPackage?.id === pickupPackage.id) {
      setSelectedPackage(updatedPackage);
    }

    setPickupDrawerOpen(false);
    setPickupForm({ idNumber: '', trackingLookup: '', phoneLookup: '' });
    setPickupPackage(null);

    alert('Colis marqué comme récupéré\nSMS envoyé à l\'expéditeur');
  };

  const openPickupForm = (pkg) => {
    setPickupPackage(pkg);
    setPickupDrawerOpen(true);
  };

  const openPackageDetails = (pkg) => {
    setSelectedPackage(pkg);
    setDrawerOpen(true);
  };

  const handleEditDestination = (dest) => {
    setEditingItem({ type: 'destination', data: { ...dest } });
  };

  const handleEditPackageType = (type) => {
    setEditingItem({ type: 'packageType', data: { ...type } });
  };

  const handleEditOperator = (op) => {
    setEditingItem({ type: 'operator', data: { ...op } });
  };

  const saveEdit = () => {
    if (editingItem.type === 'destination') {
      setDestinations(destinations.map(d => 
        d.id === editingItem.data.id ? editingItem.data : d
      ));
    } else if (editingItem.type === 'packageType') {
      setPackageTypes(packageTypes.map(p => 
        p.id === editingItem.data.id ? editingItem.data : p
      ));
    } else if (editingItem.type === 'operator') {
      setOperators(operators.map(o => 
        o.id === editingItem.data.id ? editingItem.data : o
      ));
    }
    setEditingItem(null);
  };

  const cancelEdit = () => {
    setEditingItem(null);
  };

  const startAddNew = (type) => {
    if (type === 'destination') {
      setNewItem({ type: 'destination', data: { name: '', code: '', priceMultiplier: 1.0, active: true } });
    } else if (type === 'packageType') {
      setNewItem({ type: 'packageType', data: { name: '', basePrice: 0, icon: 'Box' } });
    } else if (type === 'operator') {
      setNewItem({ type: 'operator', data: { name: '', phone: '', location: '', active: true } });
    }
    setAddingNew(true);
  };

  const saveNew = () => {
    if (newItem.type === 'destination') {
      setDestinations([...destinations, { ...newItem.data, id: destinations.length + 1 }]);
    } else if (newItem.type === 'packageType') {
      setPackageTypes([...packageTypes, { ...newItem.data, id: packageTypes.length + 1 }]);
    } else if (newItem.type === 'operator') {
      setOperators([...operators, { ...newItem.data, id: operators.length + 1 }]);
    }
    setAddingNew(false);
    setNewItem(null);
  };

  const cancelNew = () => {
    setAddingNew(false);
    setNewItem(null);
  };

  const filteredPackages = packages.filter(pkg => 
    pkg.tracking.toLowerCase().includes(searchTerm.toLowerCase()) ||
    pkg.senderPhone.includes(searchTerm) ||
    pkg.recipientPhone.includes(searchTerm) ||
    pkg.sender.toLowerCase().includes(searchTerm.toLowerCase()) ||
    pkg.recipient.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const price = calculatePrice();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <div className={`${colors.primary} text-white shadow-lg`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center">
                <span className={`font-bold text-xl ${colors.primaryText}`}>{company.logo}</span>
              </div>
              <div>
                <h1 className="text-xl font-bold">{company.name}</h1>
                <p className="text-sm opacity-90">Système de Suivi des Colis</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="text-right text-sm">
                <div className="font-medium">{currentOperator.name}</div>
                <div className="opacity-75">{currentOperator.location}</div>
              </div>
              <button className="p-2 hover:bg-white/10 rounded-lg transition">
                <LogOut className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Company Switcher */}
      <div className="bg-yellow-50 border-b border-yellow-200 py-2">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-center gap-2">
          <span className="text-xs text-yellow-800 font-medium">DÉMO:</span>
          {Object.entries(companies).map(([key, comp]) => (
            <button
              key={key}
              onClick={() => setCurrentCompany(key)}
              className={`px-3 py-1 rounded text-xs font-medium transition ${
                currentCompany === key 
                  ? 'bg-yellow-800 text-white' 
                  : 'bg-white text-yellow-800 hover:bg-yellow-100'
              }`}
            >
              {comp.name}
            </button>
          ))}
        </div>
      </div>

      {/* Navigation */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex gap-1">
            <button
              onClick={() => setView('dashboard')}
              className={`px-4 py-3 font-medium text-sm transition border-b-2 ${
                view === 'dashboard' 
                  ? `${colors.primaryBorder} ${colors.primaryText}` 
                  : 'border-transparent text-gray-600 hover:text-gray-900'
              }`}
            >
              <Package className="w-4 h-4 inline mr-2" />
              Tableau de Bord
            </button>
            <button
              onClick={() => setView('register')}
              className={`px-4 py-3 font-medium text-sm transition border-b-2 ${
                view === 'register' 
                  ? `${colors.primaryBorder} ${colors.primaryText}` 
                  : 'border-transparent text-gray-600 hover:text-gray-900'
              }`}
            >
              <Plus className="w-4 h-4 inline mr-2" />
              Enregistrer
            </button>
            <button
              onClick={() => setView('search')}
              className={`px-4 py-3 font-medium text-sm transition border-b-2 ${
                view === 'search' 
                  ? `${colors.primaryBorder} ${colors.primaryText}` 
                  : 'border-transparent text-gray-600 hover:text-gray-900'
              }`}
            >
              <Search className="w-4 h-4 inline mr-2" />
              Rechercher
            </button>
            <button
              onClick={() => setView('admin')}
              className={`px-4 py-3 font-medium text-sm transition border-b-2 ${
                view === 'admin' 
                  ? `${colors.primaryBorder} ${colors.primaryText}` 
                  : 'border-transparent text-gray-600 hover:text-gray-900'
              }`}
            >
              <Settings className="w-4 h-4 inline mr-2" />
              Administration
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className={`flex-1 transition-all duration-300 ${drawerOpen ? 'mr-[600px]' : pickupDrawerOpen ? 'mr-[500px]' : 'mr-0'}`}>
        <div className="max-w-7xl mx-auto px-6 py-6">
        {/* Dashboard */}
        {view === 'dashboard' && (
          <div className="space-y-6">
            <div className="grid grid-cols-4 gap-4">
              <div className="bg-white border border-gray-200 rounded-lg p-4">
                <div className="text-2xl font-bold text-gray-900">
                  {packages.filter(p => p.status === 'in_transit').length}
                </div>
                <div className="text-sm text-gray-600">En Transit</div>
              </div>
              <div className="bg-white border border-gray-200 rounded-lg p-4">
                <div className="text-2xl font-bold text-blue-600">
                  {packages.filter(p => p.status === 'arrived').length}
                </div>
                <div className="text-sm text-gray-600">Arrivés</div>
              </div>
              <div className="bg-white border border-gray-200 rounded-lg p-4">
                <div className="text-2xl font-bold text-green-600">
                  {packages.filter(p => p.status === 'picked_up').length}
                </div>
                <div className="text-sm text-gray-600">Récupérés</div>
              </div>
              <div className="bg-white border border-gray-200 rounded-lg p-4">
                <div className="text-2xl font-bold text-gray-900">{packages.length}</div>
                <div className="text-sm text-gray-600">Total</div>
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
              <div className="p-4 border-b border-gray-200 bg-gray-50">
                <h2 className="font-semibold text-gray-900">Colis Actifs</h2>
              </div>
              <div className="divide-y divide-gray-200">
                {packages.slice(0, 20).map(pkg => (
                  <div 
                    key={pkg.id} 
                    onClick={() => openPackageDetails(pkg)}
                    className="p-4 hover:bg-gray-50 transition cursor-pointer"
                  >
                    <div className="flex items-start justify-between mb-3">
                      <div>
                        <div className="font-mono font-bold text-lg text-gray-900 mb-1">
                          {pkg.tracking}
                        </div>
                        <div className="flex items-center gap-2">
                          <span className={`inline-block px-2 py-1 rounded text-xs font-medium ${statusLabels[pkg.status].color}`}>
                            {statusLabels[pkg.status].text}
                          </span>
                          <span className="text-sm text-gray-600">{pkg.price} CFA</span>
                        </div>
                      </div>
                      <div className="flex gap-2">
                        {pkg.status === 'in_transit' && (
                          <button
                            onClick={(e) => { e.stopPropagation(); updateStatus(pkg.id, 'arrived'); }}
                            className={`px-3 py-1 ${colors.primary} text-white rounded text-sm font-medium ${colors.primaryHover} transition`}
                          >
                            Marquer Arrivé
                          </button>
                        )}
                        {pkg.status === 'arrived' && (
                          <button
                            onClick={(e) => { e.stopPropagation(); openPickupForm(pkg); }}
                            className="px-3 py-1 bg-green-600 text-white rounded text-sm font-medium hover:bg-green-700 transition"
                          >
                            Marquer Récupéré
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-4 text-sm">
                      <div>
                        <div className="text-gray-500 text-xs mb-1">Expéditeur</div>
                        <div className="font-medium text-gray-900">{pkg.sender}</div>
                      </div>
                      <div>
                        <div className="text-gray-500 text-xs mb-1">Destinataire</div>
                        <div className="font-medium text-gray-900">{pkg.recipient}</div>
                      </div>
                      <div className="col-span-2">
                        <div className="text-gray-500 text-xs mb-1">Trajet</div>
                        <div className="font-medium text-gray-900">{pkg.origin} → {pkg.destination}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Register */}
        {view === 'register' && (
          <div className="max-w-5xl mx-auto">
            <div className="bg-white shadow-xl rounded-2xl overflow-hidden border border-gray-100">
              <div className={`p-6 ${colors.primary}`}>
                <h2 className="font-bold text-white text-2xl">Enregistrer un Nouveau Colis</h2>
                <p className="text-white/80 text-sm mt-1">Complétez les informations pour créer un nouvel envoi</p>
              </div>
              <div className="p-8">
                <div className="grid grid-cols-2 gap-8">
                  {/* Left Column */}
                  <div className="space-y-6">
                    <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                      <div className="flex items-center gap-2 mb-4">
                        <div className={`w-10 h-10 ${colors.primaryLight} rounded-lg flex items-center justify-center`}>
                          <User className={`w-5 h-5 ${colors.primaryText}`} />
                        </div>
                        <h3 className="font-semibold text-gray-900 text-lg">Expéditeur</h3>
                      </div>
                      <div className="space-y-4">
                        <div>
                          <label className="block text-sm font-semibold text-gray-700 mb-2">
                            Nom Complet <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            value={formData.senderName}
                            onChange={(e) => setFormData({...formData, senderName: e.target.value})}
                            className={`w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-${colors.primary} focus:border-transparent transition-all text-gray-900 placeholder-gray-400`}
                            placeholder="Mamadou Konaté"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-semibold text-gray-700 mb-2">
                            Téléphone <span className="text-red-500">*</span>
                          </label>
                          <div className="flex items-center gap-2">
                            <span className="px-4 py-3 bg-gray-200 border-2 border-gray-200 rounded-xl text-gray-700 font-semibold">+223</span>
                            <input
                              type="tel"
                              value={formData.senderPhone}
                              onChange={(e) => setFormData({...formData, senderPhone: e.target.value})}
                              className="flex-1 px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:border-transparent transition-all text-gray-900 placeholder-gray-400"
                              placeholder="70 12 34 56"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                      <div className="flex items-center gap-2 mb-4">
                        <div className={`w-10 h-10 ${colors.primaryLight} rounded-lg flex items-center justify-center`}>
                          <User className={`w-5 h-5 ${colors.primaryText}`} />
                        </div>
                        <h3 className="font-semibold text-gray-900 text-lg">Destinataire</h3>
                      </div>
                      <div className="space-y-4">
                        <div>
                          <label className="block text-sm font-semibold text-gray-700 mb-2">
                            Nom Complet <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            value={formData.recipientName}
                            onChange={(e) => setFormData({...formData, recipientName: e.target.value})}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:border-transparent transition-all text-gray-900 placeholder-gray-400"
                            placeholder="Fatoumata Diallo"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-semibold text-gray-700 mb-2">
                            Téléphone <span className="text-red-500">*</span>
                          </label>
                          <div className="flex items-center gap-2">
                            <span className="px-4 py-3 bg-gray-200 border-2 border-gray-200 rounded-xl text-gray-700 font-semibold">+223</span>
                            <input
                              type="tel"
                              value={formData.recipientPhone}
                              onChange={(e) => setFormData({...formData, recipientPhone: e.target.value})}
                              className="flex-1 px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:border-transparent transition-all text-gray-900 placeholder-gray-400"
                              placeholder="76 98 76 54"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Right Column */}
                  <div className="space-y-6">
                    <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                      <div className="flex items-center gap-2 mb-4">
                        <div className={`w-10 h-10 ${colors.primaryLight} rounded-lg flex items-center justify-center`}>
                          <Package className={`w-5 h-5 ${colors.primaryText}`} />
                        </div>
                        <h3 className="font-semibold text-gray-900 text-lg">Détails du Colis</h3>
                      </div>
                      <div className="space-y-4">
                        <div>
                          <label className="block text-sm font-semibold text-gray-700 mb-2">
                            Type de Colis <span className="text-red-500">*</span>
                          </label>
                          <div className="grid grid-cols-2 gap-3">
                            {packageTypes.map(type => {
                              const IconComponent = packageIcons[type.icon];
                              const isSelected = formData.packageType === type.name;
                              return (
                                <button
                                  key={type.id}
                                  onClick={() => setFormData({...formData, packageType: type.name})}
                                  className={`p-4 border-2 rounded-xl text-left transition-all ${
                                    isSelected
                                      ? `${colors.primaryBorder} ${colors.primaryLight} shadow-md`
                                      : 'border-gray-200 hover:border-gray-300 hover:shadow-sm'
                                  }`}
                                >
                                  <IconComponent className={`w-7 h-7 mb-2 ${isSelected ? colors.primaryText : 'text-gray-600'}`} />
                                  <div className="text-sm font-semibold text-gray-900">{type.name}</div>
                                  <div className="text-xs text-gray-600 font-medium">{type.basePrice} CFA</div>
                                </button>
                              );
                            })}
                          </div>
                        </div>

                        <div className="grid grid-cols-2 gap-3">
                          <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                              Départ <span className="text-red-500">*</span>
                            </label>
                            <div className="relative">
                              <MapPin className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                              <input
                                type="text"
                                value={formData.origin}
                                readOnly
                                className="w-full pl-12 pr-4 py-3 border-2 border-gray-200 rounded-xl bg-gray-100 text-gray-700 font-semibold cursor-not-allowed"
                              />
                            </div>
                          </div>
                          <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                              Destination <span className="text-red-500">*</span>
                            </label>
                            <select
                              value={formData.destination}
                              onChange={(e) => setFormData({...formData, destination: e.target.value})}
                              className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:border-transparent transition-all text-gray-900 font-medium"
                            >
                              <option value="">Choisir...</option>
                              {destinations.filter(d => d.active && d.name !== formData.origin).map(dest => (
                                <option key={dest.id} value={dest.name}>{dest.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div>
                          <label className="block text-sm font-semibold text-gray-700 mb-2">
                            Description
                          </label>
                          <textarea
                            value={formData.description}
                            onChange={(e) => setFormData({...formData, description: e.target.value})}
                            rows={3}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:border-transparent transition-all text-gray-900 placeholder-gray-400"
                            placeholder="Documents, vêtements, électronique..."
                          />
                        </div>

                        <div>
                          <label className="block text-sm font-semibold text-gray-700 mb-2">
                            Photo du Colis
                          </label>
                          <input
                            type="file"
                            accept="image/*"
                            capture="environment"
                            onChange={(e) => setFormData({...formData, photo: e.target.files?.[0] || null})}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:border-transparent transition-all text-gray-900 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                          />
                          <p className="text-xs text-gray-500 mt-1">Optionnel - Photo du colis pour référence</p>
                        </div>

                        <div>
                          <label className="block text-sm font-semibold text-gray-700 mb-2">
                            Prix Manuel (optionnel)
                          </label>
                          <div className="flex items-center gap-2">
                            <input
                              type="number"
                              value={formData.priceOverride}
                              onChange={(e) => setFormData({...formData, priceOverride: e.target.value})}
                              className="flex-1 px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:border-transparent transition-all text-gray-900 placeholder-gray-400"
                              placeholder={`Prix auto: ${price} CFA`}
                            />
                            <span className="text-sm font-medium text-gray-600">CFA</span>
                          </div>
                          <p className="text-xs text-gray-500 mt-1">Laissez vide pour utiliser le prix automatique</p>
                        </div>
                      </div>
                    </div>

                    {/* Price Preview */}
                    {(price > 0 || formData.priceOverride) && (
                      <div className="bg-gradient-to-br from-green-50 to-emerald-50 border-2 border-green-400 rounded-xl p-6 shadow-lg">
                        <div className="flex items-center justify-between mb-3">
                          <span className="text-sm font-semibold text-green-900 flex items-center gap-2">
                            <DollarSign className="w-4 h-4" />
                            Prix Total {formData.priceOverride && <span className="text-xs font-normal">(Manuel)</span>}
                          </span>
                          <span className="text-3xl font-bold text-green-900">
                            {(formData.priceOverride || price).toLocaleString()} CFA
                          </span>
                        </div>
                        {formData.origin && formData.destination && formData.packageType && (
                          <div className="text-xs text-green-800 bg-white/50 rounded-lg p-2 font-mono">
                            <strong>N° Suivi:</strong> {generateTrackingNumber()}
                          </div>
                        )}
                        {formData.photo && (
                          <div className="text-xs text-green-800 bg-white/50 rounded-lg p-2 mt-2">
                            📸 Photo attachée: {formData.photo.name}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {/* Actions */}
                <div className="flex gap-4 pt-8 mt-8 border-t-2 border-gray-200">
                  <button
                    onClick={handleRegister}
                    className={`flex-1 ${colors.primary} text-white py-4 rounded-xl font-bold ${colors.primaryHover} transition-all text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-0.5`}
                  >
                    Enregistrer le Colis
                  </button>
                  <button
                    onClick={() => setView('dashboard')}
                    className="px-10 bg-gray-100 text-gray-700 py-4 rounded-xl font-semibold hover:bg-gray-200 transition-all border-2 border-gray-200"
                  >
                    Annuler
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Search */}
        {view === 'search' && (
          <div>
            <div className="bg-white border border-gray-200 rounded-lg p-4 mb-6">
              <div className="flex gap-3">
                <div className="flex-1 relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                  <input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder="N° de suivi, téléphone, nom..."
                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
              <div className="p-4 border-b border-gray-200 bg-gray-50">
                <h2 className="font-semibold text-gray-900">
                  {filteredPackages.length} résultat{filteredPackages.length !== 1 ? 's' : ''}
                </h2>
              </div>
              <div className="divide-y divide-gray-200">
                {filteredPackages.length === 0 ? (
                  <div className="p-8 text-center text-gray-500">
                    Aucun colis trouvé
                  </div>
                ) : (
                  filteredPackages.map(pkg => (
                    <div 
                      key={pkg.id} 
                      onClick={() => openPackageDetails(pkg)}
                      className="p-4 hover:bg-gray-50 transition cursor-pointer"
                    >
                      <div className="flex items-start justify-between mb-3">
                        <div>
                          <div className="font-mono font-bold text-lg text-gray-900 mb-1">
                            {pkg.tracking}
                          </div>
                          <span className={`inline-block px-2 py-1 rounded text-xs font-medium ${statusLabels[pkg.status].color}`}>
                            {statusLabels[pkg.status].text}
                          </span>
                        </div>
                        <div className="flex gap-2">
                          {pkg.status === 'in_transit' && (
                            <button
                              onClick={(e) => { e.stopPropagation(); updateStatus(pkg.id, 'arrived'); }}
                              className={`px-3 py-1 ${colors.primary} text-white rounded text-sm font-medium ${colors.primaryHover} transition`}
                            >
                              Marquer Arrivé
                            </button>
                          )}
                          {pkg.status === 'arrived' && (
                            <button
                              onClick={(e) => { e.stopPropagation(); openPickupForm(pkg); }}
                              className="px-3 py-1 bg-green-600 text-white rounded text-sm font-medium hover:bg-green-700 transition"
                            >
                              Marquer Récupéré
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="grid grid-cols-2 gap-4 text-sm">
                        <div>
                          <div className="text-gray-500 text-xs mb-1">Expéditeur</div>
                          <div className="font-medium text-gray-900">{pkg.sender}</div>
                          <div className="text-gray-600">{pkg.senderPhone}</div>
                        </div>
                        <div>
                          <div className="text-gray-500 text-xs mb-1">Destinataire</div>
                          <div className="font-medium text-gray-900">{pkg.recipient}</div>
                          <div className="text-gray-600">{pkg.recipientPhone}</div>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        )}

        {/* Admin */}
        {view === 'admin' && (
          <div className="space-y-6">
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
              <div className="flex border-b border-gray-200">
                <button
                  onClick={() => setAdminSection('destinations')}
                  className={`flex-1 px-6 py-3 font-medium text-sm transition ${
                    adminSection === 'destinations'
                      ? `${colors.primaryText} bg-gray-50 border-b-2 ${colors.primaryBorder}`
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  <MapPinned className="w-4 h-4 inline mr-2" />
                  Destinations & Prix
                </button>
                <button
                  onClick={() => setAdminSection('packages')}
                  className={`flex-1 px-6 py-3 font-medium text-sm transition ${
                    adminSection === 'packages'
                      ? `${colors.primaryText} bg-gray-50 border-b-2 ${colors.primaryBorder}`
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  <Package className="w-4 h-4 inline mr-2" />
                  Types de Colis
                </button>
                <button
                  onClick={() => setAdminSection('operators')}
                  className={`flex-1 px-6 py-3 font-medium text-sm transition ${
                    adminSection === 'operators'
                      ? `${colors.primaryText} bg-gray-50 border-b-2 ${colors.primaryBorder}`
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  <Users className="w-4 h-4 inline mr-2" />
                  Opérateurs
                </button>
                <button
                  onClick={() => setAdminSection('reports')}
                  className={`flex-1 px-6 py-3 font-medium text-sm transition ${
                    adminSection === 'reports'
                      ? `${colors.primaryText} bg-gray-50 border-b-2 ${colors.primaryBorder}`
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  <FileText className="w-4 h-4 inline mr-2" />
                  Rapports
                </button>
              </div>

              <div className="p-6">
                {/* Destinations */}
                {adminSection === 'destinations' && (
                  <div>
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="font-semibold text-gray-900">Gérer les Destinations</h3>
                      <button
                        onClick={() => startAddNew('destination')}
                        className={`px-4 py-2 ${colors.primary} text-white rounded-lg text-sm font-medium ${colors.primaryHover}`}
                      >
                        + Ajouter Destination
                      </button>
                    </div>
                    <div className="space-y-2">
                      {addingNew && newItem?.type === 'destination' && (
                        <div className="p-4 border-2 border-green-500 rounded-lg bg-green-50">
                          <div className="grid grid-cols-4 gap-3 mb-3">
                            <input
                              type="text"
                              value={newItem.data.name}
                              onChange={(e) => setNewItem({...newItem, data: {...newItem.data, name: e.target.value}})}
                              className="px-3 py-2 border border-gray-300 rounded"
                              placeholder="Nom"
                            />
                            <input
                              type="text"
                              value={newItem.data.code}
                              onChange={(e) => setNewItem({...newItem, data: {...newItem.data, code: e.target.value}})}
                              className="px-3 py-2 border border-gray-300 rounded"
                              placeholder="Code (ex: BAM)"
                            />
                            <input
                              type="number"
                              step="0.1"
                              value={newItem.data.priceMultiplier}
                              onChange={(e) => setNewItem({...newItem, data: {...newItem.data, priceMultiplier: parseFloat(e.target.value)}})}
                              className="px-3 py-2 border border-gray-300 rounded"
                              placeholder="Multiplicateur"
                            />
                            <label className="flex items-center gap-2 px-3 py-2 border border-gray-300 rounded bg-white">
                              <input
                                type="checkbox"
                                checked={newItem.data.active}
                                onChange={(e) => setNewItem({...newItem, data: {...newItem.data, active: e.target.checked}})}
                              />
                              <span className="text-sm">Actif</span>
                            </label>
                          </div>
                          <div className="flex gap-2">
                            <button
                              onClick={saveNew}
                              className="flex-1 px-3 py-2 bg-green-600 text-white rounded text-sm font-medium hover:bg-green-700"
                            >
                              <Save className="w-4 h-4 inline mr-1" />
                              Ajouter
                            </button>
                            <button
                              onClick={cancelNew}
                              className="px-3 py-2 bg-gray-200 text-gray-700 rounded text-sm font-medium hover:bg-gray-300"
                            >
                              <X className="w-4 h-4 inline mr-1" />
                              Annuler
                            </button>
                          </div>
                        </div>
                      )}
                      {destinations.map(dest => (
                        <div key={dest.id}>
                          {editingItem?.type === 'destination' && editingItem?.data.id === dest.id ? (
                            <div className="p-4 border-2 border-blue-500 rounded-lg bg-blue-50">
                              <div className="grid grid-cols-4 gap-3 mb-3">
                                <input
                                  type="text"
                                  value={editingItem.data.name}
                                  onChange={(e) => setEditingItem({...editingItem, data: {...editingItem.data, name: e.target.value}})}
                                  className="px-3 py-2 border border-gray-300 rounded"
                                  placeholder="Nom"
                                />
                                <input
                                  type="text"
                                  value={editingItem.data.code}
                                  onChange={(e) => setEditingItem({...editingItem, data: {...editingItem.data, code: e.target.value}})}
                                  className="px-3 py-2 border border-gray-300 rounded"
                                  placeholder="Code"
                                />
                                <input
                                  type="number"
                                  step="0.1"
                                  value={editingItem.data.priceMultiplier}
                                  onChange={(e) => setEditingItem({...editingItem, data: {...editingItem.data, priceMultiplier: parseFloat(e.target.value)}})}
                                  className="px-3 py-2 border border-gray-300 rounded"
                                  placeholder="Multiplicateur"
                                />
                                <label className="flex items-center gap-2 px-3 py-2 border border-gray-300 rounded bg-white">
                                  <input
                                    type="checkbox"
                                    checked={editingItem.data.active}
                                    onChange={(e) => setEditingItem({...editingItem, data: {...editingItem.data, active: e.target.checked}})}
                                  />
                                  <span className="text-sm">Actif</span>
                                </label>
                              </div>
                              <div className="flex gap-2">
                                <button
                                  onClick={saveEdit}
                                  className="flex-1 px-3 py-2 bg-green-600 text-white rounded text-sm font-medium hover:bg-green-700"
                                >
                                  <Save className="w-4 h-4 inline mr-1" />
                                  Enregistrer
                                </button>
                                <button
                                  onClick={cancelEdit}
                                  className="px-3 py-2 bg-gray-200 text-gray-700 rounded text-sm font-medium hover:bg-gray-300"
                                >
                                  <X className="w-4 h-4 inline mr-1" />
                                  Annuler
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:bg-gray-50">
                              <div className="flex-1">
                                <div className="font-medium text-gray-900">{dest.name}</div>
                                <div className="text-sm text-gray-600">Code: {dest.code} • Multiplicateur: {dest.priceMultiplier}x</div>
                              </div>
                              <div className="flex items-center gap-2">
                                <span className={`px-2 py-1 rounded text-xs font-medium ${dest.active ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'}`}>
                                  {dest.active ? 'Actif' : 'Inactif'}
                                </span>
                                <button 
                                  onClick={() => handleEditDestination(dest)}
                                  className="p-2 text-gray-600 hover:text-blue-600"
                                >
                                  <Edit2 className="w-4 h-4" />
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Package Types */}
                {adminSection === 'packages' && (
                  <div>
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="font-semibold text-gray-900">Types de Colis & Prix de Base</h3>
                      <button
                        onClick={() => startAddNew('packageType')}
                        className={`px-4 py-2 ${colors.primary} text-white rounded-lg text-sm font-medium ${colors.primaryHover}`}
                      >
                        + Ajouter Type
                      </button>
                    </div>
                    <div className="space-y-2">
                      {addingNew && newItem?.type === 'packageType' && (
                        <div className="p-4 border-2 border-green-500 rounded-lg bg-green-50">
                          <div className="grid grid-cols-3 gap-3 mb-3">
                            <input
                              type="text"
                              value={newItem.data.name}
                              onChange={(e) => setNewItem({...newItem, data: {...newItem.data, name: e.target.value}})}
                              className="px-3 py-2 border border-gray-300 rounded"
                              placeholder="Nom"
                            />
                            <input
                              type="number"
                              value={newItem.data.basePrice}
                              onChange={(e) => setNewItem({...newItem, data: {...newItem.data, basePrice: parseInt(e.target.value)}})}
                              className="px-3 py-2 border border-gray-300 rounded"
                              placeholder="Prix de base"
                            />
                            <select
                              value={newItem.data.icon}
                              onChange={(e) => setNewItem({...newItem, data: {...newItem.data, icon: e.target.value}})}
                              className="px-3 py-2 border border-gray-300 rounded"
                            >
                              {Object.keys(packageIcons).map(iconName => (
                                <option key={iconName} value={iconName}>{iconName}</option>
                              ))}
                            </select>
                          </div>
                          <div className="flex gap-2">
                            <button
                              onClick={saveNew}
                              className="flex-1 px-3 py-2 bg-green-600 text-white rounded text-sm font-medium hover:bg-green-700"
                            >
                              <Save className="w-4 h-4 inline mr-1" />
                              Ajouter
                            </button>
                            <button
                              onClick={cancelNew}
                              className="px-3 py-2 bg-gray-200 text-gray-700 rounded text-sm font-medium hover:bg-gray-300"
                            >
                              <X className="w-4 h-4 inline mr-1" />
                              Annuler
                            </button>
                          </div>
                        </div>
                      )}
                      {packageTypes.map(type => {
                        const IconComponent = packageIcons[type.icon];
                        return (
                          <div key={type.id}>
                            {editingItem?.type === 'packageType' && editingItem?.data.id === type.id ? (
                              <div className="p-4 border-2 border-blue-500 rounded-lg bg-blue-50">
                                <div className="grid grid-cols-3 gap-3 mb-3">
                                  <input
                                    type="text"
                                    value={editingItem.data.name}
                                    onChange={(e) => setEditingItem({...editingItem, data: {...editingItem.data, name: e.target.value}})}
                                    className="px-3 py-2 border border-gray-300 rounded"
                                    placeholder="Nom"
                                  />
                                  <input
                                    type="number"
                                    value={editingItem.data.basePrice}
                                    onChange={(e) => setEditingItem({...editingItem, data: {...editingItem.data, basePrice: parseInt(e.target.value)}})}
                                    className="px-3 py-2 border border-gray-300 rounded"
                                    placeholder="Prix de base"
                                  />
                                  <select
                                    value={editingItem.data.icon}
                                    onChange={(e) => setEditingItem({...editingItem, data: {...editingItem.data, icon: e.target.value}})}
                                    className="px-3 py-2 border border-gray-300 rounded"
                                  >
                                    {Object.keys(packageIcons).map(iconName => (
                                      <option key={iconName} value={iconName}>{iconName}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="flex gap-2">
                                  <button
                                    onClick={saveEdit}
                                    className="flex-1 px-3 py-2 bg-green-600 text-white rounded text-sm font-medium hover:bg-green-700"
                                  >
                                    <Save className="w-4 h-4 inline mr-1" />
                                    Enregistrer
                                  </button>
                                  <button
                                    onClick={cancelEdit}
                                    className="px-3 py-2 bg-gray-200 text-gray-700 rounded text-sm font-medium hover:bg-gray-300"
                                  >
                                    <X className="w-4 h-4 inline mr-1" />
                                    Annuler
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:bg-gray-50">
                                <div className="flex items-center gap-3">
                                  <IconComponent className="w-6 h-6 text-gray-700" />
                                  <div>
                                    <div className="font-medium text-gray-900">{type.name}</div>
                                    <div className="text-sm text-gray-600">Prix de base: {type.basePrice} CFA</div>
                                  </div>
                                </div>
                                <button 
                                  onClick={() => handleEditPackageType(type)}
                                  className="p-2 text-gray-600 hover:text-blue-600"
                                >
                                  <Edit2 className="w-4 h-4" />
                                </button>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                {/* Operators */}
                {adminSection === 'operators' && (
                  <div>
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="font-semibold text-gray-900">Gérer les Opérateurs</h3>
                      <button
                        onClick={() => startAddNew('operator')}
                        className={`px-4 py-2 ${colors.primary} text-white rounded-lg text-sm font-medium ${colors.primaryHover}`}
                      >
                        + Ajouter Opérateur
                      </button>
                    </div>
                    <div className="space-y-2">
                      {addingNew && newItem?.type === 'operator' && (
                        <div className="p-4 border-2 border-green-500 rounded-lg bg-green-50">
                          <div className="grid grid-cols-4 gap-3 mb-3">
                            <input
                              type="text"
                              value={newItem.data.name}
                              onChange={(e) => setNewItem({...newItem, data: {...newItem.data, name: e.target.value}})}
                              className="px-3 py-2 border border-gray-300 rounded"
                              placeholder="Nom"
                            />
                            <input
                              type="tel"
                              value={newItem.data.phone}
                              onChange={(e) => setNewItem({...newItem, data: {...newItem.data, phone: e.target.value}})}
                              className="px-3 py-2 border border-gray-300 rounded"
                              placeholder="Téléphone"
                            />
                            <input
                              type="text"
                              value={newItem.data.location}
                              onChange={(e) => setNewItem({...newItem, data: {...newItem.data, location: e.target.value}})}
                              className="px-3 py-2 border border-gray-300 rounded"
                              placeholder="Localisation"
                            />
                            <label className="flex items-center gap-2 px-3 py-2 border border-gray-300 rounded bg-white">
                              <input
                                type="checkbox"
                                checked={newItem.data.active}
                                onChange={(e) => setNewItem({...newItem, data: {...newItem.data, active: e.target.checked}})}
                              />
                              <span className="text-sm">Actif</span>
                            </label>
                          </div>
                          <div className="flex gap-2">
                            <button
                              onClick={saveNew}
                              className="flex-1 px-3 py-2 bg-green-600 text-white rounded text-sm font-medium hover:bg-green-700"
                            >
                              <Save className="w-4 h-4 inline mr-1" />
                              Ajouter
                            </button>
                            <button
                              onClick={cancelNew}
                              className="px-3 py-2 bg-gray-200 text-gray-700 rounded text-sm font-medium hover:bg-gray-300"
                            >
                              <X className="w-4 h-4 inline mr-1" />
                              Annuler
                            </button>
                          </div>
                        </div>
                      )}
                      {operators.map(op => (
                        <div key={op.id}>
                          {editingItem?.type === 'operator' && editingItem?.data.id === op.id ? (
                            <div className="p-4 border-2 border-blue-500 rounded-lg bg-blue-50">
                              <div className="grid grid-cols-4 gap-3 mb-3">
                                <input
                                  type="text"
                                  value={editingItem.data.name}
                                  onChange={(e) => setEditingItem({...editingItem, data: {...editingItem.data, name: e.target.value}})}
                                  className="px-3 py-2 border border-gray-300 rounded"
                                  placeholder="Nom"
                                />
                                <input
                                  type="tel"
                                  value={editingItem.data.phone}
                                  onChange={(e) => setEditingItem({...editingItem, data: {...editingItem.data, phone: e.target.value}})}
                                  className="px-3 py-2 border border-gray-300 rounded"
                                  placeholder="Téléphone"
                                />
                                <input
                                  type="text"
                                  value={editingItem.data.location}
                                  onChange={(e) => setEditingItem({...editingItem, data: {...editingItem.data, location: e.target.value}})}
                                  className="px-3 py-2 border border-gray-300 rounded"
                                  placeholder="Localisation"
                                />
                                <label className="flex items-center gap-2 px-3 py-2 border border-gray-300 rounded bg-white">
                                  <input
                                    type="checkbox"
                                    checked={editingItem.data.active}
                                    onChange={(e) => setEditingItem({...editingItem, data: {...editingItem.data, active: e.target.checked}})}
                                  />
                                  <span className="text-sm">Actif</span>
                                </label>
                              </div>
                              <div className="flex gap-2">
                                <button
                                  onClick={saveEdit}
                                  className="flex-1 px-3 py-2 bg-green-600 text-white rounded text-sm font-medium hover:bg-green-700"
                                >
                                  <Save className="w-4 h-4 inline mr-1" />
                                  Enregistrer
                                </button>
                                <button
                                  onClick={cancelEdit}
                                  className="px-3 py-2 bg-gray-200 text-gray-700 rounded text-sm font-medium hover:bg-gray-300"
                                >
                                  <X className="w-4 h-4 inline mr-1" />
                                  Annuler
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:bg-gray-50">
                              <div className="flex-1">
                                <div className="font-medium text-gray-900">{op.name}</div>
                                <div className="text-sm text-gray-600">{op.phone} • {op.location}</div>
                              </div>
                              <div className="flex items-center gap-2">
                                <span className={`px-2 py-1 rounded text-xs font-medium ${op.active ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                                  {op.active ? 'Actif' : 'Désactivé'}
                                </span>
                                <button 
                                  onClick={() => handleEditOperator(op)}
                                  className="p-2 text-gray-600 hover:text-blue-600"
                                >
                                  <Edit2 className="w-4 h-4" />
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Reports */}
                {adminSection === 'reports' && (
                  <div className="space-y-6">
                    {/* Date Filter */}
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-medium text-gray-700">Période:</span>
                      <div className="flex gap-2">
                        <button
                          onClick={() => setDateFilter('today')}
                          className={`px-4 py-2 rounded-lg text-sm font-medium transition ${
                            dateFilter === 'today'
                              ? `${colors.primary} text-white`
                              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                          }`}
                        >
                          Aujourd'hui
                        </button>
                        <button
                          onClick={() => setDateFilter('week')}
                          className={`px-4 py-2 rounded-lg text-sm font-medium transition ${
                            dateFilter === 'week'
                              ? `${colors.primary} text-white`
                              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                          }`}
                        >
                          Cette Semaine
                        </button>
                        <button
                          onClick={() => setDateFilter('month')}
                          className={`px-4 py-2 rounded-lg text-sm font-medium transition ${
                            dateFilter === 'month'
                              ? `${colors.primary} text-white`
                              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                          }`}
                        >
                          Ce Mois
                        </button>
                      </div>
                    </div>

                    {/* Daily Stats */}
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-3">Statistiques Quotidiennes</h3>
                      <div className="grid grid-cols-4 gap-4">
                        <div className="bg-white border-2 border-gray-200 rounded-lg p-4">
                          <div className="text-sm text-gray-600 mb-1">Colis Aujourd'hui</div>
                          <div className="text-3xl font-bold text-gray-900">
                            {packages.filter(p => p.registeredAt.includes('09 Oct 2025')).length}
                          </div>
                        </div>
                        <div className="bg-white border-2 border-green-200 rounded-lg p-4">
                          <div className="text-sm text-gray-600 mb-1">Revenu Aujourd'hui</div>
                          <div className="text-3xl font-bold text-green-600">
                            {packages
                              .filter(p => p.registeredAt.includes('09 Oct 2025'))
                              .reduce((sum, p) => sum + p.price, 0)
                              .toLocaleString()} CFA
                          </div>
                        </div>
                        <div className="bg-white border-2 border-blue-200 rounded-lg p-4">
                          <div className="text-sm text-gray-600 mb-1">En Attente Retrait</div>
                          <div className="text-3xl font-bold text-blue-600">
                            {packages.filter(p => p.status === 'arrived').length}
                          </div>
                        </div>
                        <div className="bg-white border-2 border-orange-200 rounded-lg p-4">
                          <div className="text-sm text-gray-600 mb-1">Temps Transit Moyen</div>
                          <div className="text-3xl font-bold text-orange-600">6h</div>
                          <div className="text-xs text-gray-500">estimation</div>
                        </div>
                      </div>
                    </div>

                    {/* Problem Detection */}
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                        <AlertCircle className="w-5 h-5 text-red-600" />
                        Problèmes à Traiter
                      </h3>
                      <div className="space-y-2">
                        {/* Long transit packages */}
                        {packages.filter(p => p.status === 'in_transit').length > 0 && (
                          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                            <div className="font-medium text-yellow-900 mb-2">
                              ⚠️ Colis en transit prolongé ({packages.filter(p => p.status === 'in_transit').length})
                            </div>
                            <div className="space-y-2">
                              {packages.filter(p => p.status === 'in_transit').slice(0, 3).map(pkg => (
                                <div
                                  key={pkg.id}
                                  onClick={() => openPackageDetails(pkg)}
                                  className="flex items-center justify-between p-2 bg-white rounded cursor-pointer hover:bg-gray-50"
                                >
                                  <div className="text-sm">
                                    <span className="font-mono font-bold">{pkg.tracking}</span>
                                    <span className="text-gray-600 ml-2">{pkg.origin} → {pkg.destination}</span>
                                  </div>
                                  <span className="text-xs text-gray-500">{pkg.registeredAt.split(',')[0]}</span>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Unclaimed packages */}
                        {packages.filter(p => p.status === 'arrived').length > 0 && (
                          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                            <div className="font-medium text-blue-900 mb-2">
                              📦 Colis non récupérés ({packages.filter(p => p.status === 'arrived').length})
                            </div>
                            <div className="space-y-2">
                              {packages.filter(p => p.status === 'arrived').slice(0, 3).map(pkg => (
                                <div
                                  key={pkg.id}
                                  onClick={() => openPackageDetails(pkg)}
                                  className="flex items-center justify-between p-2 bg-white rounded cursor-pointer hover:bg-gray-50"
                                >
                                  <div className="text-sm">
                                    <span className="font-mono font-bold">{pkg.tracking}</span>
                                    <span className="text-gray-600 ml-2">{pkg.recipient}</span>
                                  </div>
                                  <span className="text-xs text-gray-500">Arrivé: {pkg.arrivedAt?.split(',')[0]}</span>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {packages.filter(p => p.status === 'in_transit' || p.status === 'arrived').length === 0 && (
                          <div className="bg-green-50 border border-green-200 rounded-lg p-4 text-center">
                            <CheckCircle className="w-8 h-8 text-green-600 mx-auto mb-2" />
                            <div className="font-medium text-green-900">Aucun problème détecté</div>
                            <div className="text-sm text-green-700">Tous les colis sont en bon état</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        </div>
      </div>

      {/* Package Details Drawer */}
      {drawerOpen && selectedPackage && (
        <>
          <div className="fixed right-0 top-0 h-full w-[600px] bg-white shadow-2xl z-50 overflow-y-auto transition-transform duration-300 ease-in-out">
            <div className={`${colors.primary} text-white p-6`}>
              <div className="flex items-start justify-between mb-4">
                <div>
                  <div className="font-mono text-2xl font-bold mb-2">{selectedPackage.tracking}</div>
                  <span className={`inline-block px-3 py-1 rounded-full text-sm font-medium ${statusLabels[selectedPackage.status].color}`}>
                    {statusLabels[selectedPackage.status].text}
                  </span>
                </div>
                <button 
                  onClick={() => setDrawerOpen(false)}
                  className="p-2 hover:bg-white/10 rounded-lg transition"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
              <div className="text-sm opacity-90">
                Enregistré le {selectedPackage.registeredAt}
              </div>
            </div>

            <div className="p-6 space-y-6">
              <div>
                <h3 className="font-semibold text-gray-900 mb-3">Informations</h3>
                <div className="space-y-3">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Expéditeur</div>
                      <div className="font-medium text-gray-900">{selectedPackage.sender}</div>
                      <div className="text-sm text-gray-600">{selectedPackage.senderPhone}</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Destinataire</div>
                      <div className="font-medium text-gray-900">{selectedPackage.recipient}</div>
                      <div className="text-sm text-gray-600">{selectedPackage.recipientPhone}</div>
                    </div>
                  </div>
                  <div className="grid grid-cols-3 gap-4">
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Type</div>
                      <div className="font-medium text-gray-900">{selectedPackage.packageType}</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Prix</div>
                      <div className="font-medium text-gray-900">{selectedPackage.price} CFA</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Trajet</div>
                      <div className="font-medium text-gray-900">{selectedPackage.origin} → {selectedPackage.destination}</div>
                    </div>
                  </div>
                  {selectedPackage.description && (
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Description</div>
                      <div className="text-gray-900">{selectedPackage.description}</div>
                    </div>
                  )}
                </div>
              </div>

              {selectedPackage.timeline && selectedPackage.timeline.length > 0 && (
                <div>
                  <h3 className="font-semibold text-gray-900 mb-3">Chronologie</h3>
                  <div className="relative">
                    <div className="absolute left-3 top-3 bottom-3 w-0.5 bg-gray-200" />
                    <div className="space-y-4">
                      {selectedPackage.timeline.map((event, idx) => (
                        <div key={idx} className="relative flex gap-4">
                          <div className={`w-6 h-6 rounded-full flex items-center justify-center z-10 ${
                            event.type === 'sms' ? 'bg-blue-100' : 'bg-green-100'
                          }`}>
                            {event.type === 'sms' ? (
                              <MessageSquare className="w-3 h-3 text-blue-600" />
                            ) : (
                              <div className={`w-2 h-2 rounded-full ${statusLabels[selectedPackage.status].dot}`} />
                            )}
                          </div>
                          <div className="flex-1 pb-4">
                            <div className="font-medium text-gray-900">{event.event}</div>
                            <div className="text-xs text-gray-500">{event.time}</div>
                            {event.operator && (
                              <div className="text-xs text-gray-600 mt-1">Par: {event.operator}</div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {selectedPackage.messages && selectedPackage.messages.length > 0 && (
                <div>
                  <h3 className="font-semibold text-gray-900 mb-3">Messages SMS Envoyés</h3>
                  <div className="space-y-3">
                    {selectedPackage.messages.map((msg, idx) => (
                      <div key={idx} className="bg-gray-50 border border-gray-200 rounded-lg p-3">
                        <div className="flex items-start justify-between mb-2">
                          <div className="text-xs font-medium text-gray-700">{msg.to}</div>
                          <div className="flex items-center gap-1">
                            <CheckCircle className="w-3 h-3 text-green-600" />
                            <span className="text-xs text-gray-500">{msg.time}</span>
                          </div>
                        </div>
                        <div className="text-sm text-gray-900">{msg.text}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="flex gap-3 pt-4 border-t border-gray-200">
                {selectedPackage.status === 'in_transit' && (
                  <button
                    onClick={() => { updateStatus(selectedPackage.id, 'arrived'); setDrawerOpen(false); }}
                    className={`flex-1 ${colors.primary} text-white py-3 rounded-lg font-medium ${colors.primaryHover}`}
                  >
                    Marquer Arrivé
                  </button>
                )}
                {selectedPackage.status === 'arrived' && (
                  <button
                    onClick={() => { setDrawerOpen(false); openPickupForm(selectedPackage); }}
                    className="flex-1 bg-green-600 text-white py-3 rounded-lg font-medium hover:bg-green-700"
                  >
                    Marquer Récupéré
                  </button>
                )}
              </div>
            </div>
          </div>
        </>
      )}

      {/* Pickup Verification Drawer */}
      {pickupDrawerOpen && pickupPackage && (
        <>
          <div className="fixed right-0 top-0 h-full w-[500px] bg-white shadow-2xl z-50 overflow-y-auto transition-transform duration-300 ease-in-out">
            <div className="bg-green-600 text-white p-6">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h2 className="text-xl font-bold mb-2">Vérification de Retrait</h2>
                  <div className="text-sm opacity-90">Colis: {pickupPackage.tracking}</div>
                </div>
                <button 
                  onClick={() => { setPickupDrawerOpen(false); setPickupForm({ idNumber: '', trackingLookup: '', phoneLookup: '' }); }}
                  className="p-2 hover:bg-white/10 rounded-lg transition"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
            </div>

            <div className="p-6 space-y-6">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <div className="text-sm text-blue-900 mb-2">
                  <strong>Destinataire:</strong> {pickupPackage.recipient}
                </div>
                <div className="text-sm text-blue-800">
                  <strong>Téléphone:</strong> {pickupPackage.recipientPhone}
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-900 mb-2">
                  <IdCard className="w-4 h-4 inline mr-1" />
                  Numéro de Pièce d'Identité *
                </label>
                <input
                  type="text"
                  value={pickupForm.idNumber}
                  onChange={(e) => setPickupForm({...pickupForm, idNumber: e.target.value})}
                  className="w-full px-3 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                  placeholder="Ex: CNI 123456789"
                />
                <div className="text-xs text-gray-500 mt-1">
                  Obligatoire - Vérifier la pièce d'identité du destinataire
                </div>
              </div>

              <div className="border-t border-gray-200 pt-4">
                <div className="text-sm font-medium text-gray-700 mb-3">Vérification Optionnelle</div>
                
                <div className="space-y-3">
                  <div>
                    <label className="block text-sm text-gray-700 mb-1">
                      Numéro de Suivi (optionnel)
                    </label>
                    <input
                      type="text"
                      value={pickupForm.trackingLookup}
                      onChange={(e) => setPickupForm({...pickupForm, trackingLookup: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                      placeholder={pickupPackage.tracking}
                    />
                  </div>

                  <div>
                    <label className="block text-sm text-gray-700 mb-1">
                      Téléphone (optionnel)
                    </label>
                    <input
                      type="tel"
                      value={pickupForm.phoneLookup}
                      onChange={(e) => setPickupForm({...pickupForm, phoneLookup: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                      placeholder="76 98 76 54"
                    />
                  </div>
                </div>
                
                <div className="text-xs text-gray-500 mt-2">
                  Les champs optionnels permettent une double vérification
                </div>
              </div>

              <div className="flex gap-3 pt-4">
                <button
                  onClick={handlePickupSubmit}
                  className="flex-1 bg-green-600 text-white py-3 rounded-lg font-medium hover:bg-green-700 transition"
                >
                  Confirmer le Retrait
                </button>
                <button
                  onClick={() => { setPickupDrawerOpen(false); setPickupForm({ idNumber: '', trackingLookup: '', phoneLookup: '' }); }}
                  className="px-6 bg-gray-200 text-gray-700 py-3 rounded-lg font-medium hover:bg-gray-300 transition"
                >
                  Annuler
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}